// Too Cherry: reveals [data-reveal] elements once as they scroll into view.
const observer = new IntersectionObserver(
  (entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      entry.target.classList.add('is-in');
      observer.unobserve(entry.target);
    }
  },
  { rootMargin: '0px 0px -8% 0px' }
);

function observeAll(root = document) {
  for (const el of root.querySelectorAll('.tc [data-reveal]:not(.is-in)')) observer.observe(el);
}

observeAll();
document.addEventListener('shopify:section:load', (event) => observeAll(event.target));
